import axios from "axios";
import { jwtDecode, JwtPayload } from "jwt-decode";

const apiUrl: string | undefined = process.env.REACT_APP_BASE_URL;

// if (!apiUrl) {
//     throw new Error("API URL is not defined in environment variables");
// }

export const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 450,
    bgcolor: "background.paper",
    border: "0px solid #000",
    borderRadius: "16px",
    boxShadow: 24,
    p: 8,
};

export const Loaderstyles: Record<string, React.CSSProperties> = {
    loaderContainer: {
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        background: "rgba(0, 0, 0, 0.2)",
        backdropFilter: "blur(2px)",
        zIndex: 9999,
    },
};

interface MyTokenPayload extends JwtPayload {
    email?: string;
    user_id?: string;
    masterTypeid?: number;
}

const hasStoredToken = (): boolean => {
    const token = localStorage.getItem("access_token");
    return Boolean(token && token !== "undefined" && token !== "null" && token.trim() !== "");
};

// Read-only token decode — must not clear storage (called during render).
export const decodeToken = (): MyTokenPayload | null => {
    try {
        if (!hasStoredToken()) {
            return null;
        }

        const token = localStorage.getItem("access_token") as string;
        const decoded = jwtDecode<MyTokenPayload>(token);

        if (decoded.exp && decoded.exp * 1000 < Date.now()) {
            console.warn("Token expired");
            return null;
        }

        return decoded;
    } catch (error) {
        console.error("Error decoding token:", error);
        return null;
    }
};

// Clear all auth data
export const clearAuthData = (): void => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("user");
    sessionStorage.clear();
};

// Check if token is valid without clearing storage.
export const isTokenValid = (): boolean => {
    return hasStoredToken() && decodeToken() !== null;
};

export const sendMessage = async (message: string): Promise<any> => {
    if (!isTokenValid()) {
        throw new Error("Invalid or expired token. Please login again.");
    }

    try {
        const response = await axios.post(`${apiUrl}/chat`, { "query": message });
        return response.data;
    } catch (error: any) {
        console.error('Error sending message:', error);
        throw error;
    }
};

// Never auto-logout from API errors — chat/sidebar calls must not kick user to landing page.
axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401 || error.response?.status === 403) {
            const requestUrl = error.config?.url ?? "";
            console.warn("API auth error (session kept):", requestUrl, error.response?.status);
        }
        return Promise.reject(error);
    }
);